module.exports = __webpack_public_path__ + "img/banner2.fa85c466.jpg";